var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5205 0H5.54999C2.48482 0 0 2.48482 0 5.54999V18.5205C0 21.5857 2.48482 24.0705 5.54999 24.0705H18.5205C21.5857 24.0705 24.0705 21.5857 24.0705 18.5205V5.54999C24.0705 2.48482 21.5857 0 18.5205 0Z",
    fill: "url(#paint0_linear_20569_209524)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9179 4.74856C16.8317 4.75224 17.707 5.11687 18.3532 5.76301C18.9993 6.40915 19.3639 7.28445 19.3676 8.19822V15.8718C19.3639 16.7856 18.9993 17.6609 18.3532 18.307C17.707 18.9532 16.8317 19.3178 15.9179 19.3215H8.15428C7.2405 19.3178 6.36521 18.9532 5.71907 18.307C5.07293 17.6609 4.7083 16.7856 4.70462 15.8718V8.19822C4.7083 7.28445 5.07293 6.40915 5.71907 5.76301C6.36521 5.11687 7.2405 4.75224 8.15428 4.74856H15.9179ZM15.9179 3.14407H8.15428C5.37437 3.14407 3.09961 5.42142 3.09961 8.19874V15.8718C3.09961 18.6517 5.37695 20.9265 8.15428 20.9265H15.9179C18.6979 20.9265 20.9726 18.6492 20.9726 15.8718V8.19822C20.9726 5.41831 18.6979 3.14355 15.9179 3.14355V3.14407Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0353 9.03906C12.6277 9.03906 13.2068 9.21473 13.6993 9.54385C14.1919 9.87297 14.5758 10.3408 14.8025 10.8881C15.0292 11.4354 15.0885 12.0376 14.9729 12.6186C14.8574 13.1996 14.5721 13.7333 14.1532 14.1522C13.7343 14.5711 13.2006 14.8564 12.6196 14.972C12.0386 15.0875 11.4363 15.0282 10.889 14.8015C10.3417 14.5748 9.87395 14.1909 9.54483 13.6983C9.21571 13.2058 9.04004 12.6267 9.04004 12.0343C9.041 11.2402 9.35688 10.4789 9.91838 9.9174C10.4799 9.3559 11.2412 9.04002 12.0353 9.03906ZM12.0353 7.43457C11.1255 7.43457 10.2362 7.70434 9.4798 8.20976C8.72338 8.71519 8.13382 9.43356 7.78568 10.2741C7.43754 11.1145 7.34645 12.0394 7.52393 12.9316C7.70141 13.8239 8.13949 14.6435 8.78277 15.2868C9.42606 15.9301 10.2456 16.3681 11.1379 16.5456C12.0302 16.7231 12.955 16.632 13.7955 16.2839C14.636 15.9357 15.3544 15.3462 15.8598 14.5898C16.3652 13.8333 16.635 12.944 16.635 12.0343C16.635 10.8144 16.1504 9.64441 15.2878 8.7818C14.4251 7.91918 13.2552 7.43457 12.0353 7.43457Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.737 8.32365C17.3393 8.32365 17.8276 7.8354 17.8276 7.23311C17.8276 6.63083 17.3393 6.14258 16.737 6.14258C16.1347 6.14258 15.6465 6.63083 15.6465 7.23311C15.6465 7.8354 16.1347 8.32365 16.737 8.32365Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20569_209524",
    x1: 15.7758,
    y1: 25.0808,
    x2: 8.29471,
    y2: -1.01031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDAD4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FB832E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FA7321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F6692F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E84A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#E03675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#DD2F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#B43D97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4D60D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4264DB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.07bd6372709120cbd59ae8ab9defbc28.svg";
export { ForwardRef as ReactComponent };